import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Main } from './pages/main';
import { I18nProvider } from './i18n';
import dayjs from 'dayjs';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import Maintenance from './components/maintenance/Miantenance';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export default function App({ store, basename }: { store: any; basename: any }) {
    const isTodayInMaintenance = () => {
        const now = dayjs();
        const start = dayjs('2025-07-16 13:00');
        const end = dayjs('2025-07-16 18:00');
        return now.isSameOrAfter(start) && now.isBefore(end);
    };

    return (
        <Provider store={store}>
            <BrowserRouter basename={basename}>
                <I18nProvider>{isTodayInMaintenance() ? <Maintenance /> : <Main />}</I18nProvider>
            </BrowserRouter>
        </Provider>
    );
}
